<ng-container *ngIf="!isLoading">
    <div>

        <div style="margin-left:43%;margin-bottom:1%">

            <button class="noPrint" mat-raised-button color="primary" (click)="printPage()">
                Print
            </button>

            <button class="noPrint" style="margin-left:2%" (click)="exportExcel('Taluka_Representativewise_Sadhyasthiti_Report')"
                mat-raised-button color="primary">
                Export
            </button>

            <button mat-dialog-close class="btn noPrint">
                Close
            </button>

        </div>
    </div>


    <div class="container" id="print-section">

        <table class="table table-bordered">

            <thead class="br_tp_bt">

                <tr>
                    <th colspan="8" style="border-left:2px solid black;border-right:2px solid black; font-size:18px;">
                        हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग
                    </th>
                </tr>

                <tr>
                    <th colspan="8"
                        style="border-left:2px solid black;border-right:2px solid black;border-bottom:2px solid black;text-align:right;">
                        दिनांक :- {{ endDate | date:"dd/MM/yyyy" }}
                    </th>
                </tr>

                <tr>
                    <th colspan="8" style="border:2px solid black; text-align:center; font-size:16px;">
                        तालुकानिहाय सद्यस्थिती
                    </th>
                </tr>

                <tr>
                    <th style="border-left:2px solid black;">अनुक्रमांक</th>
                    <th>जिल्हा</th>
                    <th>तालुका</th>
                    <th>पोस्ट</th>
                    <th>हस्ते</th>
                    <th>मॅगझीन</th>
                    <th>डिजिटल</th>
                    <th style="border-right:2px solid black;">एकूण</th>
                </tr>

            </thead>

            <tbody>

                <!-- ✅ PRANT -->
                <ng-container *ngFor="let prant of showPrantData">

                    <tr class="br_tp_bt">
                        <td colspan="8" class="total-bold"
                            style="border-left:2px solid black; border-right:2px solid black; border-top:2px solid black; border-bottom:2px solid black; font-weight: bold;">
                            {{ prant.prantName }}
                        </td>
                    </tr>


                    <!-- ✅ DISTRICT -->
                    <ng-container *ngFor="let district of prant.data; let i=index">

                        <!-- DISTRICT HEADER -->
                        <tr>

                            <td style="border-left:2px solid black;text-align:center; font-weight: bold;">
                                {{ i+1 }}
                            </td>

                            <td class="total-bold" style="font-weight: bold;">
                                {{ district.districtName }}
                            </td>

                            <td colspan="6"></td>

                        </tr>


                        <!-- ✅ TALUKA ROWS -->
                        <tr *ngFor="let taluka of district.talukas">

                            <td style="border-left:2px solid black;"></td>

                            <td></td>

                            <td>
                                {{ taluka.taluka }}
                            </td>

                            <td style="text-align:right;">
                                {{ taluka.post }}
                            </td>

                            <td style="text-align:right;">
                                {{ taluka.haste }}
                            </td>

                            <td style="text-align:right;">
                                {{ taluka.magazine }}
                            </td>

                            <td style="text-align:right;">
                                {{ taluka.digital }}
                            </td>

                            <td style="border-right:2px solid black;text-align:right;">
                                {{ taluka.total }}
                            </td>

                        </tr>


                        <!-- ✅ DISTRICT TOTAL -->
                        <tr class="fontBold">

                            <td colspan="3" class="total-bold"
                                style="text-align:center; font-weight:bold; border-top:2px solid black; border-bottom:2px solid black; border-left:2px solid black;">
                                {{ district.districtName }} - एकूण
                            </td>

                            <td
                                style="text-align:right; font-weight:bold; border-top:2px solid black; border-bottom:2px solid black;">
                                {{ district.post }}
                            </td>

                            <td
                                style="text-align:right; font-weight:bold; border-top:2px solid black; border-bottom:2px solid black;">
                                {{ district.haste }}
                            </td>

                            <td
                                style="text-align:right; font-weight:bold; border-top:2px solid black; border-bottom:2px solid black;">
                                {{ district.magazine }}
                            </td>

                            <td
                                style="text-align:right; font-weight:bold; border-top:2px solid black; border-bottom:2px solid black;">
                                {{ district.digital }}
                            </td>

                            <td
                                style="border-right:2px solid black;text-align:right; font-weight:bold; border-top:2px solid black; border-bottom:2px solid black;">
                                {{ district.total }}
                            </td>

                        </tr>

                    </ng-container>

                </ng-container>



                <!-- ✅ OTHER PRANT -->
                <tr *ngFor="let item of showOtherPrantData; let i=index">

                    <td style="border-left:2px solid black;text-align:center;">
                        {{ i+1 }}
                    </td>

                    <td>{{ item.name }}</td>

                    <td></td>

                    <td style="text-align:right;">{{ item.post }}</td>
                    <td style="text-align:right;">{{ item.haste }}</td>
                    <td style="text-align:right;">{{ item.magazine }}</td>
                    <td style="text-align:right;">{{ item.digital }}</td>

                    <td style="border-right:2px solid black;text-align:right;">
                        {{ item.total }}
                    </td>

                </tr>



                <!-- ✅ GRAND TOTAL -->
                <tr class="fontBold br_tp_bt">

                    <td colspan="3" style="border-left:2px solid black;text-align:center;">
                        एकूण
                    </td>

                    <td style="text-align:right;">{{ totalPostTotal }}</td>
                    <td style="text-align:right;">{{ totalHasteTotal }}</td>
                    <td style="text-align:right;">{{ totalMagzineTotal }}</td>
                    <td style="text-align:right;">{{ totalDigitalTotal }}</td>

                    <td style="border-right:2px solid black;text-align:right;">
                        {{ totalPostTotal + totalHasteTotal + totalMagzineTotal + totalDigitalTotal }}
                    </td>

                </tr>

            </tbody>

        </table>
    </div>
</ng-container>


<div *ngIf="isLoading" class="main-loading">
    <span class="loader"></span>
    <p>Loading...</p>
</div>